import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class RestoreDetectedAmountsCommand {
    
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(document_id:number, user_id:number): Promise<any> {
    let args = { 
        document_id: document_id,
        user_id: user_id
    }
    this.frontend.loading_update_restore(true)
    let b = await this.frontend.confirm_restore()
    if(b){
      await this.dispatcher.dispatch('restore_amounts_with_detected.data', args)
      await this.frontend.fetchDocument({ id: document_id})
      this.frontend.getCurrencyInfo()
    }
    this.frontend.loading_update_restore(false)
  }
}